import constants from '$$helpers/constants';
import { DARKEST_COLORS, WEEK_LOCALES, MONTH_LOCALES } from './constants';
import rights from '../../components/rights/index';
import store from '$$globalStore';
import ganttViewModel from '$$ganttViewModel';
import moment from 'moment';
import routerHelper from '$$routerHelper';

const calendarHelpers = {
  getTasksMap(tasks, tasksMap) {
    tasksMap.clear();
    tasks.forEach(task => tasksMap.set(task.id, task));

    return tasksMap;
  },
  prepareCalendarEvents(tasks) {
    return tasks.filter(task => task.type === 'task')
      .filter(task => this.hasAccessToTask(task))
      .map(task => this.prepareEvent(task));
  },
  prepareEvent(taskData) {
    const preparedColors = constants.PALETTE_CONFIG.palette.flat().map(item => ({
      ...item,
      dark_color: DARKEST_COLORS[item.color],
    }));
    const defaultColor = preparedColors.find(item => item.color === '#50C7D6');
    const taskColor = preparedColors.find(item => item.id === +taskData?.color);

    return {
      id: taskData.id,
      start_date: taskData.start_date,
      end_date: taskData.end_date,
      text: taskData.text,
      ganttId: taskData.gantt_id,
      allDay: true,
      color: {
        background: taskColor?.color || defaultColor?.color,
        border: taskColor?.color || defaultColor?.color,
        darkColor: taskColor?.dark_color || defaultColor?.dark_color,
      },
    };
  },
  hasSomeTasksWithAccess(tasks) {
    return tasks.some(task => this.hasAccessToTask(task));
  },
  tasksWithAccess(tasks) {
    return tasks.filter(task => this.hasAccessToTask(task));
  },
  hasAccessToTask(task) {
    if (!task) return false;
    if (this.hasAccessToAllTasks(task.gantt_id)) return true;

    const userId = rights.getUserId();
    const resourceData = store.getters['resourcesModel/getResourceByUserId'](userId);

    return task.resources?.find(r => r.resource_id === resourceData.id);
  },
  hasAccessToAllTasks(ganttId) {
    return rights.project.hasRight(ganttId, 'all_tasks');
  },
  hasAccessToCreateTask(projectId) {
    return rights.project.hasRight(projectId, 'create_task');
  },
  checkAccessToTasks(projectId) {
    const tasks = store.getters['tasksModel/getTasksForGantt'](projectId).data;

    return this.hasAccessToAllTasks(projectId) || this.hasSomeTasksWithAccess(tasks);
  },
  getWeekendCssSelector(cellDate, calendarConfig) {
    if (!calendarConfig) {
      return;
    }

    const dates = calendarConfig.dates;
    const preparedDates = {};

    Object.entries(dates).forEach(([key, value]) => {
      let current = +key;

      if (key.length > 1) {
        const date = new Date(+key);
        const momentData = moment(date);
        const day = momentData.startOf('day');

        current = new Date(day).getTime();
      }

      preparedDates[current] = value;
    });

    const calendarDate = new Date(cellDate);
    const calendarDayTime = calendarDate.getTime();
    const dayOfWeek = calendarDate.getDay();

    if ((preparedDates[dayOfWeek] === false && !preparedDates[calendarDayTime]?.length) || preparedDates[calendarDayTime] === false) {
      return 'custom-weekend';
    }

    return '';
  },
  isTaskStartDateBlockedByLinkDependencies(taskData) {
    const isWorkloadPage = routerHelper.isWorkloadViewRoute();
    const projectData = ganttViewModel.getActiveViewData();

    if (!projectData.config.auto_scheduling && projectData.isSingleProject && !isWorkloadPage) {
      return false;
    }

    if (!taskData.auto_scheduling && (!projectData.isSingleProject || isWorkloadPage)) {
      return false;
    }

    const mastersData = store.getters['tasksModel/getTargetLinksByGanttIdAndTaskId'](projectData.gantt_id, taskData.id);
    let shouldBlock = false;

    mastersData.forEach(masterData => {
      switch (masterData.type) {
      case constants.GANTT_LINK_TYPES.finish_to_start:
      case constants.GANTT_LINK_TYPES.start_to_start:
        shouldBlock = true;
        break;
      }
    });

    return shouldBlock;
  },
  getDateData(ms) {
    const date = new Date(ms);
    const month = date.getMonth();
    const dayOfMonth = date.getDate();
    const dayOfWeek = date.getDay();

    return {
      fullDate: date,
      month: MONTH_LOCALES[month],
      dayMonth: dayOfMonth,
      dayWeek: WEEK_LOCALES[dayOfWeek],
    };
  },
};

export default calendarHelpers;
